module.exports = __webpack_public_path__ + "static/media/Eelektross_gaussian2.281ec35e.png";